import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateProjectFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.projectsUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.projectsFilters]);
    },
  });
};
